"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _bcmKunrenActions = require("../bcmKunrenActions");
var _KunrenInfoField = _interopRequireDefault(require("../common/components/KunrenInfoField"));
var _ChecksheetSummaryResultField = _interopRequireDefault(require("./components/ChecksheetSummaryResultField"));
var _EvaluationField = _interopRequireDefault(require("./components/EvaluationField"));
var _ReportGuidelinesField = _interopRequireDefault(require("./components/ReportGuidelinesField"));
var _TaskField = _interopRequireDefault(require("./components/TaskField"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var Yup = _interopRequireWildcard(require("yup"));
var _Consts = require("../common/consts/Consts");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const FieldSpace = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1)
  };
});

/**
 * 訓練実施報告登録
 */
const KunrenReportEntry = props => {
  const {
    intl,
    callAPI,
    goMain,
    checkDirty,
    setDirty,
    setEntries,
    setPreviousEntries,
    setContent,
    openConfirm,
    openInfoBar,
    setEntry,
    kunrenInfo,
    reportEntry
  } = props;
  const [isCustomCheck, setIsCustomCheck] = _react.default.useState(true);
  _react.default.useEffect(() => {
    if (kunrenInfo) {
      callAPI(_APIs.BCM_KUNREN_REPORT, kunrenInfo).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setEntries(response.data);
          setPreviousEntries(response.data);
        }
      }).catch(e => {
        if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
          return;
        }
        throw e;
      });
    }
    window.scrollTo(0, 0);
  }, [callAPI, kunrenInfo, setEntries, setPreviousEntries]);
  const schema = _react.default.useMemo(() => {
    const pleaseSelectMsg = intl.formatMessage({
      id: _labelConsts.LABEL.CORE_PLEASE_SELECT
    });
    const lengthMsg = n => intl.formatMessage({
      id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
    }, {
      0: n
    });
    return Yup.object({
      submitRequiredFlag: Yup.boolean().nullable(),
      exercisesDtRequiredFlag: Yup.boolean().nullable(),
      scenarioPolicyCd: Yup.string().nullable(),
      exercisesDt: (0, _validationHelpers.requiredWhen)(intl, 'exercisesDtRequiredFlag', f => !!f, (0, _validationHelpers.dateTimeOrEmpty)(intl)),
      checkStatusList: Yup.array().of(Yup.object({
        notes: Yup.string().max(10, lengthMsg(10)).nullable()
      })).nullable().test('tgt-risk-required', pleaseSelectMsg, function (list) {
        var _this$parent, _this$parent2;
        const submitReq = (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.submitRequiredFlag;
        const scenarioPolicyCd = (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.scenarioPolicyCd;
        if (!submitReq) return true;
        if (!(scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !scenarioPolicyCd)) return true;
        if (!Array.isArray(list)) return false;
        return list.some(item => {
          if (item.checkKbn !== _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) return false;
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            return !!(item.notes && String(item.notes).trim() !== '');
          }
          return item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1;
        });
      }),
      riskDetailNotes: Yup.string().max(1000, lengthMsg(1000)),
      kunrenPurpose: Yup.string().max(1000, lengthMsg(1000)),
      kunrenContent: Yup.string().max(1000, lengthMsg(1000)),
      supplement: Yup.string().max(1000, lengthMsg(1000)),
      partcipant: Yup.string().max(6, lengthMsg(6)),
      kunrenResult: Yup.string().max(1000, lengthMsg(1000)),
      kunrenEvaluation: (0, _validationHelpers.optionalStringTrimMax)(intl, 1000),
      hqComments: (0, _validationHelpers.optionalStringTrimMax)(intl, 1000),
      reportResultList: Yup.array().of(Yup.object({
        _submitRequiredFlag: Yup.boolean().nullable(),
        teamName: Yup.string().max(20, lengthMsg(20)).test('teamNameRequired', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
        }), function (v) {
          const {
            replyNum,
            understand,
            effect,
            teamComment
          } = this.parent || {};
          const someFilled = replyNum !== '' && replyNum !== undefined || understand !== '' && understand !== undefined || effect !== '' && effect !== undefined || teamComment !== '' && teamComment !== undefined;
          if (someFilled) return !!v;
          return true;
        }),
        replyNum: Yup.string().max(5, lengthMsg(5)).test('numeric', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_ENTER_HALF_NUMERIC
        }), v => !v || !isNaN(v)).test('min1', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_VALUE_LEAST_MESSAGE
        }, {
          0: _Consts.CONSTS.REPLY_NUM_MIN
        }), v => !v || Number(v) >= 1).test('required', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
        }), function (v) {
          var _this$parent3;
          const submitReq = (_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3._submitRequiredFlag;
          const {
            teamName
          } = this.parent || {};
          if (!submitReq) return true;
          if (teamName && (v === '' || v === undefined)) return false;
          return true;
        }),
        understand: Yup.string().test('range', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_ENTER_VALUE_BETWEEN
        }, {
          0: _Consts.CONSTS.UNDERSTAND_MIN_STR,
          1: _Consts.CONSTS.UNDERSTAND_MAX_STR
        }), v => !v || !isNaN(v) && parseFloat(v) >= _Consts.CONSTS.UNDERSTAND_MIN_NUM && parseFloat(v) <= _Consts.CONSTS.UNDERSTAND_MAX_NUM).test('required', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
        }), function (v) {
          var _this$parent4;
          const submitReq = (_this$parent4 = this.parent) === null || _this$parent4 === void 0 ? void 0 : _this$parent4._submitRequiredFlag;
          const {
            teamName
          } = this.parent || {};
          if (!submitReq) return true;
          if (teamName && (v === '' || v === undefined)) return false;
          return true;
        }),
        effect: Yup.string().test('range', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_ENTER_VALUE_BETWEEN
        }, {
          0: _Consts.CONSTS.EFFECT_MIN_STR,
          1: _Consts.CONSTS.EFFECT_MAX_STR
        }), v => !v || !isNaN(v) && parseFloat(v) >= _Consts.CONSTS.EFFECT_MIN_NUM && parseFloat(v) <= _Consts.CONSTS.EFFECT_MAX_NUM).test('required', intl.formatMessage({
          id: _labelConsts.LABEL.CORE_REQUIRED_MESSAGE
        }), function (v) {
          var _this$parent5;
          const submitReq = (_this$parent5 = this.parent) === null || _this$parent5 === void 0 ? void 0 : _this$parent5._submitRequiredFlag;
          const {
            teamName
          } = this.parent || {};
          if (!submitReq) return true;
          if (teamName && (v === '' || v === undefined)) return false;
          return true;
        }),
        teamComment: Yup.string().max(1000, lengthMsg(1000))
      })).nullable(),
      // 課題：行単位（行内に _submitRequiredFlag 埋込）
      repTaskList: Yup.array().of(Yup.object({
        _submitRequiredFlag: Yup.boolean().nullable(),
        task: Yup.string().max(1000, lengthMsg(1000)),
        schedule: Yup.string().max(10, lengthMsg(10)),
        bumon: Yup.string().nullable().test('bumonRequired', pleaseSelectMsg, function (v) {
          var _this$parent6;
          const submitReq = (_this$parent6 = this.parent) === null || _this$parent6 === void 0 ? void 0 : _this$parent6._submitRequiredFlag;
          const {
            task
          } = this.parent || {};
          if (!submitReq) return true;
          if (task && (!v || v === '')) return false;
          return true;
        }),
        kind: Yup.string().nullable().test('kindRequired', pleaseSelectMsg, function (v) {
          var _this$parent7;
          const submitReq = (_this$parent7 = this.parent) === null || _this$parent7 === void 0 ? void 0 : _this$parent7._submitRequiredFlag;
          const {
            bumon
          } = this.parent || {};
          if (!submitReq) return true;
          if (bumon && (!v || v === '')) return false;
          return true;
        }),
        taio: Yup.string().nullable().test('taioRequired', pleaseSelectMsg, function (v) {
          var _this$parent8;
          const submitReq = (_this$parent8 = this.parent) === null || _this$parent8 === void 0 ? void 0 : _this$parent8._submitRequiredFlag;
          const {
            bumon,
            kind
          } = this.parent || {};
          if (!submitReq) return true;
          if (!kind) return true;
          if (bumon === _Consts.CONSTS.TASK_JITAISAKUHONBU && (!v || v === '')) return false;
          return true;
        })
      })).nullable()
    });
  }, [intl]);
  const {
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: {
      errors
    }
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues: {
      submitRequiredFlag: isCustomCheck,
      exercisesDtRequiredFlag: isCustomCheck,
      scenarioPolicyCd: reportEntry.scenarioPolicyCd,
      exercisesDt: reportEntry.exercisesDt,
      checkStatusList: reportEntry.checkStatusList,
      reportResultList: reportEntry.reportResultList,
      repTaskList: reportEntry.repTaskList,
      riskDetailNotes: reportEntry.riskDetailNotes,
      kunrenPurpose: reportEntry.kunrenPurpose,
      kunrenContent: reportEntry.kunrenContent,
      supplement: reportEntry.supplement,
      partcipant: reportEntry.partcipant,
      kunrenResult: reportEntry.kunrenResult,
      // 追加：評価項目
      kunrenEvaluation: reportEntry.kunrenEvaluation,
      hqComments: reportEntry.hqComments
    },
    shape: schema
  });
  _react.default.useEffect(() => {
    reset({
      submitRequiredFlag: isCustomCheck,
      exercisesDtRequiredFlag: isCustomCheck,
      scenarioPolicyCd: reportEntry.scenarioPolicyCd,
      exercisesDt: reportEntry.exercisesDt,
      checkStatusList: reportEntry.checkStatusList,
      reportResultList: reportEntry.reportResultList,
      repTaskList: reportEntry.repTaskList,
      riskDetailNotes: reportEntry.riskDetailNotes,
      kunrenPurpose: reportEntry.kunrenPurpose,
      kunrenContent: reportEntry.kunrenContent,
      supplement: reportEntry.supplement,
      partcipant: reportEntry.partcipant,
      kunrenResult: reportEntry.kunrenResult,
      // 追加：評価項目
      kunrenEvaluation: reportEntry.kunrenEvaluation,
      hqComments: reportEntry.hqComments
    }, {
      keepErrors: true,
      keepDirty: true,
      keepTouched: true,
      keepIsSubmitted: true
    });
  }, [isCustomCheck, reportEntry.scenarioPolicyCd, reportEntry.exercisesDt, reportEntry.checkStatusList, reportEntry.reportResultList, reportEntry.repTaskList, reportEntry.riskDetailNotes, reportEntry.kunrenPurpose, reportEntry.kunrenContent, reportEntry.supplement, reportEntry.partcipant, reportEntry.kunrenResult, reportEntry.kunrenEvaluation, reportEntry.hqComments, reset]);
  const submitWithFlag = reg => () => {
    setIsCustomCheck(reg);
    const vals = getValues();
    const repTaskListWithFlag = (vals.repTaskList || []).map(row => _objectSpread(_objectSpread({}, row), {}, {
      _submitRequiredFlag: reg
    }));
    const reportResultListWithFlag = (vals.reportResultList || []).map(row => _objectSpread(_objectSpread({}, row), {}, {
      _submitRequiredFlag: reg
    }));
    setValue('repTaskList', repTaskListWithFlag, {
      shouldValidate: false,
      shouldDirty: false
    });
    setValue('reportResultList', reportResultListWithFlag, {
      shouldValidate: false,
      shouldDirty: false
    });
    setValue('submitRequiredFlag', reg, {
      shouldValidate: false,
      shouldDirty: false
    });
    setValue('exercisesDtRequiredFlag', reg, {
      shouldValidate: false,
      shouldDirty: false
    });
    setEntry('repTaskList')(repTaskListWithFlag);
    setEntry('reportResultList')(reportResultListWithFlag);
    setEntry('submitRequiredFlag')(reg);
    setEntry('exercisesDtRequiredFlag')(reg);
    handleSubmit(() => onValid(reg), onInvalid)();
  };
  const onValid = reg => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: reg ? _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE : _labelConsts.LABEL.CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE
    }), () => {
      const repTaskList = reportEntry.repTaskList.map(item => ({
        taskNo: item.taskNo,
        taskCd: item.taskCd,
        schedule: item.schedule,
        task: item.task,
        bumon: item.bumon,
        kind: item.kind,
        taio: item.taio
      }));
      const reportResultAverage = _objectSpread(_objectSpread({}, reportEntry.reportResultAverage), {}, {
        teamName: intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_AVERAGE
        })
      });
      const sendData = _objectSpread(_objectSpread({}, reportEntry), {}, {
        targetCd: kunrenInfo.targetCd,
        bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
        bcpTgtJigyoCd: kunrenInfo.bcpTgtJigyoCd,
        repTaskList,
        reportResultAverage
      });
      if (reg) {
        callAPI(_APIs.BCM_KUNREN_REPORT_REGISTER, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setDirty(false);
            setContent(_bcmKunrenActions.CONTENTS.REPORT_ENTRY_RESULT);
          }
        });
      } else {
        callAPI(_APIs.BCM_KUNREN_REPORT_SAVE, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setDirty(false);
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_TEMP_STORE_MESSAGE
            }, {
              0: props.getCodeName(_CodeConsts.CODE.DOCUMENT_KIND.KBN, _CodeConsts.CODE.DOCUMENT_KIND.CODE_KJH)
            }));
            goMain(true);
          }
        });
      }
    });
  };
  const onInvalid = () => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  };
  const setField = key => value => {
    setEntry(key)(value);
    setValue(key, value, {
      shouldValidate: false,
      shouldDirty: false
    });
  };
  const setArrayField = key => newList => {
    setEntry(key)(newList);
    setValue(key, newList, {
      shouldValidate: false,
      shouldDirty: false
    });
  };
  const returnButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => checkDirty(() => goMain(false)),
    autoWidth: true,
    negative: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
  }));
  const deleteButton = reportEntry.krPrgCd !== _CodeConsts.CODE.BCM_KR_PROG_CD.CODE_0 ? /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.CORE_DELETE_CONFIRM_MESSAGE
      }), () => {
        const sendData = {
          targetCd: kunrenInfo.targetCd,
          bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
          bcpTgtJigyoCd: kunrenInfo.bcpTgtJigyoCd
        };
        callAPI(_APIs.BCM_KUNREN_REPORT_DELETE, sendData).then(response => {
          if (response.status === _APIs.STATUS.SUCCESS) {
            setContent(_bcmKunrenActions.CONTENTS.REPORT_DELETE_RESULT);
            setDirty(false);
          }
        });
      });
    },
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_DELETE
  })) : null;
  const saveButton = reportEntry.krPrgCd !== _CodeConsts.CODE.BCM_KR_PROG_CD.CODE_1 ? /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: submitWithFlag(false),
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TEMP_STORE
  })) : null;
  const registerButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: submitWithFlag(true),
    autoWidth: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));
  const actions = [returnButton];
  if (deleteButton) actions.push(deleteButton);
  if (saveButton) actions.push(saveButton);
  actions.push(registerButton);
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(() => onValid(true), onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_REPORT_REGISTER
    }),
    actions: actions
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_KunrenInfoField.default, {
    data: kunrenInfo
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_REPORT_JISSHI_DETAIL
    }),
    hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_JISSHI_DETAIL_HELP
  }, /*#__PURE__*/_react.default.createElement(_ReportGuidelinesField.default, {
    reportEntry: reportEntry,
    setEntry: setField,
    kunrenInfo: kunrenInfo,
    isCustomCheck: isCustomCheck,
    errors: errors,
    setFormValue: setValue
  })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_REPORT_TASK_TITLE
    }),
    hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_TASK_TITLE_HELP
  }, /*#__PURE__*/_react.default.createElement(_TaskField.default, {
    reportEntry: reportEntry,
    setEntry: setField,
    setList: setArrayField('repTaskList'),
    kunrenInfo: kunrenInfo,
    isCustomCheck: isCustomCheck,
    errors: errors,
    setFormValue: setValue
  })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_REPORT_CHECKSHEET_RESULT
    }),
    hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_CHECKSHEET_RESULT_HELP
  }, /*#__PURE__*/_react.default.createElement(_ChecksheetSummaryResultField.default, {
    reportEntry: reportEntry,
    setEntry: setField,
    setList: setArrayField('reportResultList'),
    isCustomCheck: isCustomCheck,
    errors: errors,
    setFormValue: setValue
  })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(FieldSpace, null, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_REPORT_COMMENT_TITLE
    })
  }, /*#__PURE__*/_react.default.createElement(_EvaluationField.default, {
    reportEntry: reportEntry,
    setEntry: setField,
    errors: errors
  }))))))));
};
const mapStateToProps = state => ({
  kunrenInfo: state.bcmKunren.kunrenInfo,
  reportEntry: state.bcmKunren.reportEntry,
  reportErrMsg: state.bcmKunren.reportErrMsg
});
const mapDispatchToProps = dispatch => {
  return {
    goMain: doSearch => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.GO_MAIN](doSearch)),
    setEntry: key => value => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_REPORT_ENTRY](key, value));
    },
    setEntries: reportEntry => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_REPORT_ENTRIES](reportEntry)),
    setPreviousEntries: previousReportEntry => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_PREVIOUS_REPORT_ENTRIES](previousReportEntry)),
    setContent: content => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.SET_CONTENT](content)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    setDirty: dirty => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](dirty))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CodeUtil.withCodeUtil)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KunrenReportEntry))));